<template>
    <div class="font-theme" v-if="isReady" v-resize="onResize">
        <v-row no-gutters class="standard-row font-theme" :class="editButton.history_dashboard? 'budget-dashboard-card1' : 'budget-dashboard-card'">
            <v-col cols="12" sm="12" md="" lg="" v-if="editButton.history_dashboard" class="animate-history-dashboard-budget-card mb-5 mb-md-0" :class="{ 'mr-3' : editButton.history_dashboard}">
                <v-card class="budget-history-table-card pb-5 pb-md-3">
                    <v-row class="standard-row font-theme pl-5 pt-5" style="font-weight: 700; font-size: 15px;">
                        History
                    </v-row>
                    <v-row no-gutters class="standard-row font-theme px-2 pt-2 header-history-budget-dashboard" align="center">
                        <v-col cols="4" sm="4" md="5" lg="5" style="background-color: #D9D9D9; border-radius: 5px 0 0 5px; text-align: center;">
                            Date
                        </v-col>
                        <v-col cols="8" sm="8" md="7" lg="7" style="background-color: #D9D9D9; border-radius: 0 5px 5px 0; text-align: center;">
                            Editor
                        </v-col>
                    </v-row>
                    <div class="scrollbar-history-budget-dashboard-tab">
                        <template v-if="historyBudgetList.length">
                            <v-row v-for="(editors, index) in historyBudgetList" :key="`${editors}${index}`" no-gutters @click="searchHistoryBudget(editors, index)" class="standard-row font-theme px-2 pt-3 selected-history-budget-dashboard" :class="{ 'active-selected-history-budget-dashboard' : selectedHistoryBudget.index === index }" align="center" style="font-size: 13px; color: #A0A0A0;">
                                <v-col cols="4" sm="4" md="5" lg="5" style="text-align: center;">
                                    <v-icon size="8" color="#D9D9D9">mdi-circle</v-icon>
                                    <span class="pl-1"> {{ editors.history_date }} </span>
                                </v-col>
                                <v-col cols="8" sm="8" md="7" lg="7" class="d-flex justify-center justify-md-start" style="text-align: start;">
                                    {{ editors.edit_full_name }}
                                </v-col>
                            </v-row>
                        </template>
                        <template v-else>
                            <v-row no-gutters class="standard-row font-theme px-2 pt-3 d-flex justify-center" align="center" style="font-size: 13px; color: #A0A0A0;">
                                ไม่พบข้อมูล
                            </v-row>
                        </template>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" sm="12" :md="editButton.history_dashboard? (windowSize.x <= 1050? '8' : '9') : '12'" :lg="editButton.history_dashboard? (windowSize.x <= 1530? '9' : '10') : '12'" class="table-budget-dashboard-card">
                <v-row no-gutters class="standard-row font-theme pt-2 px-8" style="font-weight: 700; font-size: 20px;" align="center">
                    <span class="mr-2">
                        Budgeting {{ budget_type }}
                    </span>
                    <v-col :cols="windowSize.x > 374 ? 4: 6" sm="3" md="2" lg="2">
                        <v-select class="standard-row font-theme d-flex justify-center budget-dashboard-dropdown-select-year" :menu-props="{ bottom: true, offsetY: true }" hide-details height="30" outlined v-model="year_selected" :prepend-inner-icon="windowSize.x > 428 ? 'mdi-calendar' : ''" append-icon="mdi-chevron-down" :items="year_list" style="border-radius: 10px;max-height: none;" @change="goToPage(page)">
                        </v-select>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-menu offset-y v-if="windowSize.x <= 600">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="#414040">
                                <v-icon size="30">mdi-menu</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="background-color: #414040;">
                            <template v-if="page === 1">
                            <span v-if="!editButton.edit_button">
                                <v-list-item dense v-if="!editButton.history_dashboard && checkPrivilegeButton">
                                    <v-list-item-content @click="editButton.edit_button = true">
                                        <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Edit</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item dense :class="{'active-selected-event-button-mobile' : editButton.history_dashboard}">
                                    <v-list-item-content @click="editButton.history_dashboard? (searchGroupBudget(), editButton.history_dashboard = false) : getListHistoryBudget(true)">
                                        <v-list-item-title class="font-theme" :class="editButton.history_dashboard? 'black--text' : 'white--text'" style="font-size: 16px; line-height: 25px;">History</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item dense v-if="Object.keys(selectedHistoryBudget).length">
                                    <v-list-item-content @click="download_report_history_budget()">
                                        <v-list-item-title  class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Download</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                 <v-list-item dense v-if="!editButton.history_dashboard">
                                    <v-list-item-content @click="download_report_budget()">
                                        <v-list-item-title  class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Download</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </span>
                            <span v-else>
                                <v-list-item dense v-if="!saveForCheckValue.check_edit_event || saveForCheckValue.check_edit_event === 'name'" :class="{'active-selected-event-button-mobile' : editButton.edit_name}">
                                    <v-list-item-content @click="editNameToggle()">
                                        <v-list-item-title class="font-theme" :class="editButton.edit_name? 'black--text' : 'white--text'" style="font-size: 16px; line-height: 25px;">Edit Name</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item dense v-if="budgetType && (!saveForCheckValue.check_edit_event || saveForCheckValue.check_edit_event === 'number')" :class="{'active-selected-event-button-mobile' : editButton.edit_number}">
                                    <v-list-item-content @click="editNumberToggle()">
                                        <v-list-item-title class="font-theme" :class="editButton.edit_number? 'black--text' : 'white--text'" style="font-size: 16px; line-height: 25px;">Edit Number</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item dense v-if="!saveForCheckValue.check_edit_event || saveForCheckValue.check_edit_event === 'add_group'">
                                    <v-list-item-content @click="openAddGroupModal()">
                                        <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Add Group</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item dense v-if="!saveForCheckValue.check_edit_event || saveForCheckValue.check_edit_event === 'delete'" :class="{'active-selected-event-button-mobile' : editButton.delete_data}">
                                    <v-list-item-content @click="editDeleteToggle()">
                                        <v-list-item-title class="font-theme" :class="editButton.delete_data? 'black--text' : 'white--text'" style="font-size: 16px; line-height: 25px;">Delete</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item dense>
                                    <v-list-item-content @click="saveAllData()">
                                        <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Done</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </span>
                            </template>
                            <template v-if="page === 2">
                                <v-list-item dense>
                                    <v-list-item-content @click="addFileExcelBudgeting()">
                                        <v-list-item-title
                                            class="font-theme white--text"
                                            style="font-size: 16px; line-height: 25px;"
                                        >
                                           Import Excel
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item dense>
                                    <v-list-item-content @click="download_report_budget()">
                                        <v-list-item-title
                                            class="font-theme white--text"
                                            style="font-size: 16px; line-height: 25px;"
                                        >
                                            Download
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </v-row>
                <v-row  no-gutters class="standard-row font-theme pt-3 px-8 d-flex justify-space-between">
                    <v-col cols="12" sm="12" md="auto" lg="auto" v-if="windowSize.x > 600 "> <!--button for pc -->
                         <v-btn v-if="page === 2" rounded color="green" class="white--text text-center download-report-vendor-btn mr-2"
                                @click="addFileExcelBudgeting">
                                <v-icon class="mr-1">mdi-plus</v-icon>
                                    Import Excel
                        </v-btn>
                        <template v-if="!editButton.edit_button">
                            <v-btn v-if="!editButton.history_dashboard && checkPrivilegeButton && page === 1" height="25" color="#0B68D6" @click="editButton.edit_button = true" class="px-3 mr-2 button-header-budget-permission">
                                Edit
                            </v-btn>
                            <v-btn v-if="page === 1" height="25" :color="editButton.history_dashboard? '#FF0000' : '#0B68D6'" @click="editButton.history_dashboard? (searchGroupBudget(), editButton.history_dashboard = false, selectedHistoryBudget = {}) : getListHistoryBudget(true)" class="px-3 mr-2 button-header-budget-permission">
                                History
                            </v-btn>
                            <v-btn v-if="Object.keys(selectedHistoryBudget).length && page === 1" @click="download_report_history_budget()" height="25" color="#0B68D6" class="px-3 button-header-budget-permission">
                                Download
                            </v-btn>
                            <v-btn
                            v-if="!editButton.history_dashboard"
                            @click="download_report_budget()"
                            rounded
                            color="#0B68D6"
                            depressed
                            :height="page === 1 ? 25 : 36"
                            :class="{
                                'white--text': true,
                                'text-capitalize': true,
                                'elevation-1': true,
                                'download-report-vendor-btn-page2': page === 2,
                                'pt-0': page === 2,
                            'font-weight-bold': page === 2,
                                'mt-0': page === 2,
                                'px-6': page === 2,
                                'button-header-budget-permission': page === 1,
                                'px-3': page === 1
                            }"
                            >
                            <v-icon v-if="page === 2" left size="20" class="mr-1">
                            mdi mdi-download
                            </v-icon>
                            Download
                            </v-btn>
                        </template>
                        <div v-else>
                            <v-btn height="25" :color="editButton.edit_name? '#FF0000' : '#0B68D6'" :disabled="['number', 'delete', 'add_group'].includes(saveForCheckValue.check_edit_event)" @click="editNameToggle()" class="px-3 button-header-budget-permission">
                                Edit Name
                            </v-btn>
                            <v-btn v-if="budgetType" height="25" :disabled="['name', 'delete', 'add_group'].includes(saveForCheckValue.check_edit_event)" :color="editButton.edit_number? '#FF0000' : '#0B68D6'" @click="editNumberToggle()" class="px-3 ml-2 button-header-budget-permission">
                                Edit Number
                            </v-btn>
                            <v-btn height="25" color="#0B68D6" :disabled="['name', 'delete', 'number'].includes(saveForCheckValue.check_edit_event)" @click="openAddGroupModal()" class="px-3 ml-2 button-header-budget-permission">
                                Add Group
                            </v-btn>
                            <v-btn height="25" width="47" :color="editButton.delete_data? '#FF0000' : '#0B68D6'" :disabled="['number', 'name', 'add_group'].includes(saveForCheckValue.check_edit_event)" @click="editButton.delete_data = !editButton.delete_data, saveForCheckValue.check_edit_event = 'delete'" class="px-0 ml-2 button-header-budget-permission">
                                <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.42871 2.875H15.5716V14.125C15.5716 15.1605 14.4843 16 13.143 16H5.85728C4.51602 16 3.42871 15.1605 3.42871 14.125V2.875ZM9.50014 1C10.8414 1 11.9287 1.83947 11.9287 2.875H7.07157C7.07157 1.83947 8.15888 1 9.50014 1Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M1 2.875H18" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7.07129 5.6875V13.1875" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M11.9287 5.6875V13.1875" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </v-btn>
                            <v-btn height="25" color="#333333" @click="saveAllData()" class="px-3 ml-2 button-header-budget-permission">
                                Done
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" :lg="windowSize.x < 1300? '6' : '7'" class="mt-lg-n6">
                        <v-row no-gutters class="standard-row font-theme mt-md-4 mt-lg-0" align="center">
                            <v-col  cols="12" sm="12" md="3" lg="3" class="pl-lg-7 pr-md-4 pr-lg-0">
                                <v-row v-if="page === 1" no-gutters height="31px" color="black" class="pl-2 standard-row font-theme topics-budget-box-header mt-sm-4 mt-md-0">
                                    Budget
                                </v-row>
                                <v-row v-if="page === 1" no-gutters class="standard-row font-theme">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field hide-details outlined v-on="on" v-bind="attrs" height="62" readonly v-model="budgetDashboardData.total" background-color="#3B639F" class="topics-budget-box-value centered-input-dashboard-budget budget-value"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ budgetDashboardData.total }} บาท</span>
                                    </v-tooltip>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="3" lg="3" class="pl-lg-7 pr-md-4 pr-lg-0">
                                <v-row no-gutters height="31px" color="black" class="pl-2 standard-row font-theme topics-budget-box-header mt-sm-4 mt-md-0">
                                    Plan
                                </v-row>
                                <v-row no-gutters class="standard-row font-theme">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field hide-details outlined v-on="on" v-bind="attrs" height="62" readonly v-model="budgetDashboardData.budget_plan" background-color="#D9D9D9" class="topics-budget-box-value centered-input-dashboard-budget plan-value"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ budgetDashboardData.budget_plan }} บาท</span>
                                    </v-tooltip>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="3" lg="3" class="pl-lg-7 mt-4 mt-md-0 px-md-2 px-lg-0">
                                <v-row no-gutters height="31px" color="black" class="pl-2 standard-row font-theme topics-budget-box-header">
                                    Actual
                                </v-row>
                                <v-row no-gutters class="standard-row font-theme">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field hide-details outlined v-on="on" v-bind="attrs" height="62" readonly v-model="budgetDashboardData.budget_actual" background-color="#D9D9D9" class="topics-budget-box-value centered-input-dashboard-budget actual-value"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ budgetDashboardData.budget_actual }} บาท</span>
                                    </v-tooltip>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12" md="3" lg="3" class="pl-lg-7 mt-4 mt-md-0 pl-md-4 pl-lg-0">
                                <v-row no-gutters height="31px" color="black" class="pl-2 standard-row font-theme topics-budget-box-header">
                                    Total
                                </v-row>
                                <v-row no-gutters class="standard-row font-theme">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field hide-details outlined v-on="on" v-bind="attrs" height="62" readonly v-model="budgetDashboardData.budget_total" background-color="#FF8000B2" class="topics-budget-box-value centered-input-dashboard-budget total-value"></v-text-field>
                                        </template>
                                        <span class="font-theme">{{ budgetDashboardData.budget_total }} บาท</span>
                                    </v-tooltip>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters class="standard-row font-theme px-8">
                    <v-col cols="" sm="" md="" lg="" class="mt-5 mt-lg-n3">
                        <v-slide-group show-arrows mandatory v-model="budgetType" @change="changeTypeEvent()" color="#414040">
                            <v-slide-item v-slot="{ active, toggle }" value="">
                                <v-btn :input-value="active" @click="toggle" height="25" depressed rounded text active-class="active-button-group-budgeting-permission" class="button-group-budgeting-permission">
                                    Total
                                </v-btn>
                            </v-slide-item>
                            <v-slide-item v-slot="{ active, toggle }" value="plan">
                                <v-btn :input-value="active" @click="toggle" height="25" depressed rounded text active-class="active-button-group-budgeting-permission" class="button-group-budgeting-permission">
                                    Plan
                                </v-btn>
                            </v-slide-item>
                            <v-slide-item v-slot="{ active, toggle }" value="actual">
                                <v-btn :input-value="active" @click="toggle" height="25" depressed rounded text active-class="active-button-group-budgeting-permission" class="button-group-budgeting-permission">
                                    Actual
                                </v-btn>
                            </v-slide-item>
                        </v-slide-group>
                    </v-col>
                </v-row>
                <v-form ref="budgetForm" lazy-validation>
                    <v-row no-gutters class="standard-row font-theme px-5 pt-2">
                        <v-simple-table class="mb-3 data-table-dashboard-budget" fixed-header :loading="true">
                            <template v-slot:default>                     
                                <thead>
                                    <tr style="border-radius: 10px solid #333333;">
                                        <th style="width: 20%;" class="text-left group-name-dashboard-budget-table-header budget-group-column">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-select hide-details outlined dense height="28" append-icon="mdi-chevron-down" :disabled="editButton.edit_button" v-bind="attrs" v-on="on" :items="budgetDashboardData.group_budget" v-model="selectedGroup" @change="filterDataByGroup(selectedGroup)" item-text="group_name" background-color="#D9D9D9" color="#333333" :menu-props="{ bottom: true, offsetY: true }" return-object class="font-theme budget-dashboard-dropdown-select-group">
                                                        <template v-slot:item="data">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="font-theme" style="line-height: 18px;">{{ data.item.group_name }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                        <template v-slot:no-data>
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-theme" style="line-height: 18px;">ไม่พบข้อมูล</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-select>
                                                </template>
                                                <span>{{ selectedGroup.group_name }}</span>
                                            </v-tooltip>
                                        </th>
                                        <th class="dashboard-budget-table-header">Jan</th>
                                        <th class="dashboard-budget-table-header">Feb</th>
                                        <th class="dashboard-budget-table-header">Mar</th>
                                        <th class="dashboard-budget-table-header">Apr</th>
                                        <th class="dashboard-budget-table-header">May</th>
                                        <th class="dashboard-budget-table-header">Jun</th>
                                        <th class="dashboard-budget-table-header">Jul</th>
                                        <th class="dashboard-budget-table-header">Aug</th>
                                        <th class="dashboard-budget-table-header">Sep</th>
                                        <th class="dashboard-budget-table-header">Oct</th>
                                        <th class="dashboard-budget-table-header">Nov</th>
                                        <th class="dashboard-budget-table-header">Dec</th>
                                        <th class="text-center total-dashboard-budget-table-header">Total</th>
                                    </tr>
                                </thead>
                                <tbody v-if="Object.keys(budgetDashboardData).length? budgetDashboardData.group_budget_body_table.length : false">
                                    <tr v-for="(item, index) in budgetDashboardData.group_budget_body_table"
                                        :key="`budget-row-${item._id || 'no-id'}-${item.level}-${index}`"
                                    >
                                    <td v-if="!editButton.edit_name" class="text-left group-name-dashboard-table-body budget-group-column" :class="{ 'pt-7': item.level === 0 || (page === 2 && index === 0) }">
                                        <div class="dashboard-group-name" :class="{
                                            'dashboard-group-name-total': item.level === 0,
                                            'dashboard-group-name-detail': item.level !== 0,
                                            'dashboard-row-level-2': item.level === 1,
                                            'dashboard-group-name-edited': item.edit_type === 'edit_group_name'
                                        }"
                                        :style="{ paddingLeft: `${item.level * 12}px` }"
                                        >
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span v-bind="attrs" v-on="on">
                                                        <v-btn v-if="editButton.delete_data && item.level < 5" @click="openDeleteGroupModal(item, index)" fab dark color="#FF0000" width="15" height="15" elevation="1" class="mr-2 animate-show-card">
                                                            <v-icon size="16">
                                                                mdi-minus
                                                            </v-icon>
                                                        </v-btn>
                                                    </span>
                                                </template>
                                                <span class="font-theme">Delete {{ convertTooltipHeader(item.level)  }}</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span v-bind="attrs" v-on="on">
                                                        <v-btn v-if="editButton.edit_number && item.level < 5 && (item.level !== 0 || permissionEditNumber === true)" @click="eachEditNumberToggle(item, index), tempIndexEditNumber.push(index)" fab dark :color="item.edit_number_status? '#FF0000' : '#0B68D6'" width="15" height="15" elevation="1" class="mr-2 animate-show-card">
                                                            <v-icon size="12">
                                                                mdi-pencil
                                                            </v-icon>
                                                        </v-btn>
                                                    </span>
                                                </template>
                                                <span class="font-theme">Edit Number</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span v-bind="attrs" v-on="on" class="dashboard-group-name-text"
                                                        :style="{
                                                            fontWeight: item.level <= 1 ? 700 : 400,
                                                            fontSize: item.level <= 1 ? '13px' : '12px',
                                                            color: 'black'
                                                        }">
                                                        {{ item.group_name }}
                                                    </span>
                                                </template>
                                                <span class="font-theme">{{ item.group_name }}</span>
                                            </v-tooltip>
                                        </div>
                                        </td>
                                        <td v-else class="text-left group-name-dashboard-table-body budget-group-column" :class="{ 'pt-7': item.level === 0 }">
                                            <v-row no-gutters class="standard-row font-theme dashboard-group-edit-row" align="center" :style="{ paddingLeft: `${item.level * 12}px` }">
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <span v-bind="attrs" v-on="on" class="dashboard-group-action">
                                                            <v-btn
                                                                v-if="editButton.delete_data"
                                                                @click="openDeleteGroupModal(item, index)"
                                                                fab
                                                                dark
                                                                color="#FF0000"
                                                                width="15"
                                                                height="15"
                                                                elevation="1"
                                                                class="animate-show-card"
                                                            >
                                                                <v-icon size="16">
                                                                    mdi-minus
                                                                </v-icon>
                                                            </v-btn>
                                                        </span>
                                                    </template>
                                                    <span class="font-theme">Delete {{ convertTooltipHeader(item.level) }}</span>
                                                </v-tooltip>
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <span v-bind="attrs" v-on="on" class="dashboard-group-action">
                                                            <v-btn
                                                                v-if="editButton.edit_number && item.level < 5 && (item.level !== 0 || permissionEditNumber === true)"
                                                                @click="eachEditNumberToggle(item, index), tempIndexEditNumber.push(index)"
                                                                fab
                                                                dark
                                                                :color="item.edit_number_status ? '#FF0000' : '#0B68D6'"
                                                                width="15"
                                                                height="15"
                                                                elevation="1"
                                                                class="animate-show-card"
                                                            >
                                                                <v-icon size="12">
                                                                    mdi-pencil
                                                                </v-icon>
                                                            </v-btn>
                                                        </span>
                                                    </template>
                                                    <span class="font-theme">Edit Number</span>
                                                </v-tooltip>
                                                <span v-if="item.level === 0" style="font-weight: 700; color: black;" class="font-theme input-each-group-dashboard-budget">{{ item.group_name }}</span>
                                                <v-text-field
                                                    v-else
                                                    :style="{
                                                        fontWeight: item.level === 1 ? 700 : 400,
                                                        color: 'black'
                                                    }"
                                                    hide-details
                                                    outlined
                                                    height="22"
                                                    color="black"
                                                    @focus="setValueForCheck(index)"
                                                    v-model="item.group_name"
                                                    class="font-theme input-each-group-dashboard-budget dashboard-group-edit-input"
                                                    :rules="[v => !!v]"
                                                    required
                                                ></v-text-field>
                                            </v-row>
                                        </td>
                                        <td v-for="(month, mIndex) in item.budget" :key="mIndex" class="dashboard-budget-table-body"
                                            :class="{ 'pt-7': item.level === 0 || (page === 2 && index === 0) }"
                                            :style="{ padding: mIndex === 0 ? '1px 2px 1px 8px' : mIndex === item.budget.length - 1 ? '1px 8px 1px 2px' : '1px 2px' }">
                                            <v-row v-if="!item.edit_number_status" class="standard-row dashboard-budget-cell-row d-flex justify-center" no-gutters
                                                :style="{fontSize: item.level === 0 ? '13px' : '12px', backgroundColor: month.edit ? '#CFE2B3' : item.level === 0 ? '#A9C5C3' : item.level === 1 ? '#b8e3e0' : '#F5F5F5', fontWeight: item.level <= 1 ? 700 : 400 }">
                                                {{ month.amount }}
                                            </v-row>
                                            <TextFieldEdit v-else :item="item" :index="index" v-model="month.amount"
                                                @focus="setValueForCheck(index, mIndex)" @keyup="calculateTotalNumber(item)" required
                                                :style="{ fontWeight: item.level <= 1 ? 700 : 400, backgroundColor: '#FFFFFF' }" />
                                        </td>
                                        <td class="dashboard-budget-table-body total-budget-dashboard-table-body"
                                            :class="{ 'pt-7': item.level === 0 || (page === 2 && index === 0) }" style="padding: 1px 8px;">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-row v-bind="attrs" v-on="on" class="standard-row dashboard-budget-cell-row d-flex justify-center" no-gutters
                                                        :style="{ fontSize: item.level === 0 ? '13px' : '12px', backgroundColor: item.level === 0 ? '#A9C5C3' : item.level === 1 ? '#b8e3e0' : '#D9D9D9', fontWeight: item.level <= 1 ? 700 : 400 }">
                                                        {{ !Number.isFinite(Number(String(item.sum_amount ?? '').replace(/,/g, ''))) || Number(String(item.sum_amount ?? '').replace(/,/g, '')) === 0 ? '-' : Number(String(item.sum_amount).replace(/,/g, '')).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                                    </v-row>
                                                </template>
                                                <span class="font-theme">
                                                    {{ !Number.isFinite(Number(String(item.sum_amount ?? '').replace(/,/g, ''))) || Number(String(item.sum_amount ?? '').replace(/,/g, '')) === 0 ? '-' : Number(String(item.sum_amount).replace(/,/g, '')).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                                </span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr style="pointer-events: none;">
                                        <td colspan="14" class="px-0">
                                            <v-row class="standard-row no-data-budget-dashboard-table d-flex align-end">
                                                ไม่พบข้อมูล
                                            </v-row>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-row>
                </v-form> 
                <div v-if="budget_type !==  'RD'" style="padding: 20px 30px; display: flex; justify-content: end; align-items: center; gap: 10px;">
                    <v-btn
                    v-if="page === 2" icon @click="goToPage(1)" >
                    <v-icon size="33" color="#000">mdi-chevron-left-circle-outline</v-icon>
                    </v-btn>
                    <span v-if="page === 1" class="text-bold">1 จาก 2</span>
                    <v-btn
                    v-if="page === 1"
                    icon @click="goToPage(2)">
                    <v-icon size="33" color="#000">mdi-chevron-right-circle-outline</v-icon>
                    </v-btn>
                    <span v-if="page === 2" class="text-bold"> 2 จาก 2</span>
                </div>
            </v-col>
        </v-row>
        <ConfirmDeleteGroupModal />
        <AddGroupDashboardBudget />
        <AddExcelBudgetingModal />
    </div>
</template>

<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
import ConfirmDeleteGroupModal from '../components/ConfirmDeleteGroupModal.vue'
import AddGroupDashboardBudget from '../components/AddGroupDashboardBudget.vue'
import TextFieldEdit from "../components/module/TextFieldEditBudgetDashboard.vue"
import AddExcelBudgetingModal from '../components/addExcelBudgetingModal.vue'
export default {
    components: {
        AddExcelBudgetingModal,
        TextFieldEdit,
        ConfirmDeleteGroupModal,
        AddGroupDashboardBudget
    },
    props: [
        "budget_type"
    ],
    data: () => ({
        windowSize: { x: 0 },
        editButton: {
            "edit_name"         : false,
            "edit_button"       : false,
            "edit_number"       : false,
            "delete_data"       : false,
            "history_dashboard" : false
        },
        checkPrivilegeButton: false,
        isReady: false,
        newValueChanged: [],
        budgetType: '',
        callApiPending: 0,
        permissionEditNumber:false,
        page: 1,
        callcheckApiPending: 0,
        callcheckApiPendingPerson: 0,
        selectedBiz: null,
        tempDeleteGroup: [],
        historyBudgetList: [],
        tempIndexEditNumber: [],
        budgetDashboardData: {},
        selectedHistoryBudget: {},
        budgetDashboardCloneData: {},
        sumTotal: 0,
        selectedGroup: { "_id" : null, "group_name" : 'All'},
        budgetRules: [ v => v !== null && v !== undefined && v !== '' ],
        saveForCheckValue: { name: {}, value: {}, check_edit_event: null },
        year_selected: new Date().getFullYear().toString(),
        year_list: [
            (new Date().getFullYear() - 2).toString(),
            (new Date().getFullYear() - 1).toString(),
            new Date().getFullYear().toString()
        ]
    }),
    beforeDestroy () {
         EventBus.$off('kepDataRefresh', this.year,this.page)
        EventBus.$off('afterAddGroupBudget')
        EventBus.$off('afterConfirmDeleteGroup')
    },
    mounted () { 
        EventBus.$on('kepDataRefresh', this.kepDataPage)
        this.selectedBiz = this.$store.state.confirmSelectedBiz
        this.onResize()
        if (this.page === 1) {
                this.searchGroupBudget()
            } else if (this.page === 2) {
                this.searchGroupBudgetV2()
        }
        EventBus.$on('afterAddGroupBudget', this.searchGroupBudget)
        EventBus.$on('afterConfirmDeleteGroup', this.confirmDeleteGroup)
       
        if(this.selectedBiz.tax_id === '0107544000094') this.checkButtonPermission()
        else this.checkButtonPermissionJV()
    },
    watch: {
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {
                EventBus.$emit('loadingState', false)
            }
        },
        '$route.query'() {
            this.$nextTick(() => {
                this.isReady                  = false
                this.budgetType               = ''
                this.budgetDashboardData      = {}
                this.budgetDashboardCloneData = {}
                this.selectedGroup = { 
                    "_id" : null,
                    "group_name" : 'All'
                },
                this.editButton = {
                    "edit_name"         : false,
                    "edit_button"       : false,
                    "edit_number"       : false,
                    "delete_data"       : false,
                    "history_dashboard" : false
                },
                this.saveForCheckValue = { 
                    "name"             : {},
                    "value"            : {},
                    "check_edit_event" : null 
                }
                 if (this.page === 1) {
                    this.searchGroupBudget()
                } else if (this.page === 2) {
                    this.searchGroupBudgetV2()
                }
                this.checkPrivilegeButton     = false
                if(this.selectedBiz.tax_id === '0107544000094') this.checkButtonPermission()
                else this.checkButtonPermissionJV()
            })
        }
    },
    methods: {
        goToPage(num) {
            this.page = num
            if (this.page === 1) {
                this.searchGroupBudget()
            } else if (this.page === 2) {
                this.editButton.history_dashboard = false
                this.searchGroupBudgetV2()
            }
        },
        kepDataPage(year,page){
            this.year_selected = year
            this.page = page
            if (this.page === 1) {
                this.searchGroupBudget()
            } else if (this.page === 2) {
                this.searchGroupBudgetV2()
            }
        },
        async checkButtonPermissionJV() {
            try {
                this.callcheckApiPendingPerson++;
                const response = await this.axios.get(`${this.$api_url}/permission_dashboard/api/v1/check_permission_dashboard_JV?tax_id=${this.selectedBiz.tax_id}`);
                const personalIdentity = response.data.data.personalIdentity;
                this.checkPrivilegeButton = personalIdentity;
            } catch (error) {
                console.log('Error fetching button permission:', error);
            } finally {
                this.callcheckApiPendingPerson--;
            }
        },
        async checkButtonPermission() {
            try {
                this.callcheckApiPending++;
                const response = await this.axios.get(`${this.$api_url}/permission_dashboard/api/v1/check_permission_dashboard_inet`);
                const privilege = response.data.data.privilege;
                this.checkPrivilegeButton = privilege;
                const totalResponse = await this.axios.get(`${this.$api_url}/permission_dashboard/api/v1/permission_total`)
                this.permissionEditNumber = totalResponse.data.data.permission
            } catch (error) {
                console.log(error)
            } finally {
                this.callcheckApiPending--;
            }
        },
        onResize() {
            this.windowSize = { x: window.innerWidth }
            this.$nextTick(() => {
                this.updateBudgetGroupColumnWidth()
            })
        },
        updateBudgetGroupColumnWidth() {
                const wrapper = document.querySelector('.data-table-dashboard-budget > .v-data-table__wrapper')
                if (!wrapper) return
                const wrapperWidth = wrapper.clientWidth
                if (!wrapperWidth) return
                wrapper.style.setProperty('--budget-group-column-width',`${wrapperWidth * 0.2}px`)
        },
        async download_report_history_budget() {
            try {
                this.callApiPending++
                const data = await this.axios.get(`${this.$api_url}report/api/v1/export_reporthistory?budget_type=${this.budget_type || ''}&type=${this.budgetType || ''}&tax_id=${this.selectedBiz.tax_id || ''}&history_date_string=${this.selectedHistoryBudget.history_date_string || ''}`, { responseType: "blob" })
                if (data.data) {
                    const link = document.createElement("a")
                    link.href  = window.URL.createObjectURL(new Blob([data.data]))
                    link.setAttribute("download", `history dashboard budget ${this.selectedHistoryBudget.history_date}.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    this.alert('ดาวน์โหลดรายงานสำเร็จ', 'Success', 'success')
                } else {
                    this.alert('ดาวน์โหลดรายงานไม่สำเร็จ', 'Fail', 'error')
                }
            } catch (error) {
                this.alert('ดาวน์โหลดรายงานไม่สำเร็จ', 'Fail', 'error')
                console.log(error)
            } finally {
                this.callApiPending--
            }      
        },
        async download_report_budget() {
            try {
                this.callApiPending++
                const url = this.page === 2 ? '/report/api/v1/export_report_dashbord_budget_V2' : '/report/api/v1/export_report_dashbord_budget';
                const config = {
                    baseURL: this.$api_url,
                    url: url,
                    method: "GET",
                    responseType: "blob",
                    params: {
                        tax_id: this.selectedBiz.tax_id || '',
                        budget_type: this.budget_type || '',
                        type: this.budgetType || '',
                        year: this.year_selected
                    }
                }
                const data = await this.axios(config)
                if (data.data) {
                    const link = document.createElement("a")
                    link.href  = window.URL.createObjectURL(new Blob([data.data]))
                    link.setAttribute("download", `Report dashboard budget ${this.budgetType === '' ? 'total' : this.budgetType} ${this.budget_type.toLowerCase()} ${MainFunction.shortDate(new Date())}.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    this.alert('ดาวน์โหลดรายงานสำเร็จ', 'Success', 'success')
                } else {
                    this.alert('ดาวน์โหลดรายงานไม่สำเร็จ', 'Fail', 'error')
                }
            } catch (error) {
                this.alert('ดาวน์โหลดรายงานไม่สำเร็จ', 'Fail', 'error')
                console.log(error)
            } finally {
                this.callApiPending--
            }      
        },
        convertDataApiToTable(groupBudget, budget_type) {
            const result = []
            const sourceGroups = Array.isArray(groupBudget) ? groupBudget : []
            const formatAmount = (value) => {
                if (value === null || value === undefined || value === '') return value
                const raw = String(value).replace(/,/g, '').trim()
                if (raw === '-') return '-'
                const number = Number(raw)
                return Number.isFinite(number)
                    ? number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    : value
            }
            const normalizeBudget = (budget) => {
                if (!Array.isArray(budget)) return []
                return budget.map((item) => ({
                    month: item?.month,
                    amount: formatAmount(item?.amount),
                    edit: !!item?.edit
                }))
            }
            const getGroupName = (item) => String(item?.group_name ?? '').trim()
            const hasGroupName = (item) => getGroupName(item) !== ''
            const getLevel = (item, level) => {
                const name = getGroupName(item).toLowerCase()
                if (level >= 2 && ['plan', 'actual'].includes(name) && !budget_type) {
                    return 4
                }
                return level
            }
        const createRow = (
            item,
            level,
            type,
            isGroupTotal = false,
            sourceGroupId = null
        ) => {
            const budget = isGroupTotal
                ? normalizeBudget(
                    item?.group_budget_total ||
                    item?.budget
                )
                : normalizeBudget(item?.budget)

            return {
                _id: isGroupTotal
                    ? `${sourceGroupId || item?._id || type}`
                    : item?._id,
                // _id ของ group_budget
                transaction_id:
                    item?.transaction_id ||
                    item?._id ||
                    null,
                group_budget_total_id:
                    item?.group_budget_total_id ||
                    null,
                source_group_id:
                    sourceGroupId,

                is_group_total:
                    isGroupTotal,
                edit_number_status:
                    false,
                edit_type:
                    isGroupTotal
                        ? null
                        : item?.edit_type,
                level,
                type,
                group_name:
                    isGroupTotal
                        ? (
                            item?.group_total_name ||
                            'BUDGET'
                        )
                        : getGroupName(item),

                group_total_name:
                    isGroupTotal
                        ? (
                            item?.group_total_name ||
                            'BUDGET'
                        )
                        : item?.group_total_name,

                sum_amount:
                    isGroupTotal
                        ? formatAmount(
                            budget.reduce(
                                (sum, month) => {
                                    const amount =
                                        Number(
                                            String(
                                                month?.amount ?? 0
                                            )
                                                .replace(/,/g, '')
                                                .trim()
                                        )

                                    return sum +
                                        (
                                            Number.isFinite(amount)
                                                ? amount
                                                : 0
                                        )
                                },
                                0
                            )
                        )
                        : formatAmount(
                            item?.sum_amount
                        ),

                budget,

                budget_total:
                    normalizeBudget(
                        item?.group_budget_total
                    )
            }
        }
            const enumerateSubGroup = (budget, parentType, level) => {
                if (!Array.isArray(budget)) return

                budget.forEach((item, index) => {
                    // ไม่สร้าง row ว่างในตาราง
                    if (!hasGroupName(item)) return

                    const type = `${parentType}_${index}`
                    const rowLevel = getLevel(item, level)

                    result.push(createRow(item, rowLevel, type))

                    if (Array.isArray(item?.group_budget) && item.group_budget.length) {
                        enumerateSubGroup(item.group_budget, type, level + 1)
                    }
                })
            }

            sourceGroups.forEach((group, index) => {
                // group หลักที่ไม่มีชื่อไม่ควรถูกสร้างเป็น row เปล่า
                if (!hasGroupName(group)) return

                const type = `group${index}`
                const groupRow = createRow(group, 1, type)

                result.push(groupRow)

                if (Array.isArray(group?.group_budget) && group.group_budget.length) {
                    enumerateSubGroup(group.group_budget, type, 2)
                }
            })
            return result
        },

        buildBudgetTableData(baseTableData) {
            const baseData = Array.isArray(baseTableData) ? baseTableData : []
            const tableData = []

            baseData.forEach((group, groupIndex) => {
                if (group?.level !== 1 || !String(group?.group_name ?? '').trim()) return

                const totalRow = {
                    _id: `${group._id || groupIndex}`,
                    group_budget_total_id: group.group_budget_total_id || null,
                    source_group_id: group._id,
                    is_group_total: true,
                    edit_number_status: false,
                    edit_type: null,
                    level: 0,
                    type: `${group.type || groupIndex}`,
                    group_name: group.group_total_name || 'BUDGET',
                    group_total_name: group.group_total_name || 'BUDGET',
                    budget: Array.isArray(group.budget_total) ? group.budget_total : [],
                    sum_amount: (
                        (Array.isArray(group.budget_total) ? group.budget_total : []).reduce((sum, item) => {
                            const amount = Number(String(item?.amount ?? 0).replace(/,/g, '').trim())
                            return sum + (Number.isFinite(amount) ? amount : 0)
                        }, 0)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                }

                tableData.push(totalRow)
                tableData.push(group)

                const groupIndexInBase = baseData.indexOf(group)
                const nextGroupIndex = baseData.findIndex(
                    (item, index) => index > groupIndexInBase && item?.level === 1
                )
                const endIndex = nextGroupIndex === -1 ? baseData.length : nextGroupIndex

                tableData.push(...baseData.slice(groupIndexInBase + 1, endIndex))
            })

            return tableData
        },
        // createGroupBudgetTree(data) {
        //     let result = []
        //     for (let i = 0; i < data.length; i++) {
        //         switch(data[i].type) {
        //             case 'group':
        //                 result.push(data[i])
        //                 break;
        //             case 'sub_group1':
        //                 if (!result[result.length - 1].group_budget?.length) {
        //                     result[result.length - 1].group_budget = []
        //                 }
        //                 result[result.length - 1].group_budget.push(data[i])
        //                 break;
        //             case 'sub_group2':
        //                 if (!result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget?.length) {
        //                     result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget = []
        //                 }
        //                 result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget.push(data[i])
        //                 break;
        //             case 'sub_group3':
        //                 if (!result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget[result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget.length - 1].group_budget?.length) {
        //                     result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget[result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget.length - 1].group_budget = []
        //                 }
        //                 result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget[result[result.length - 1].group_budget[result[result.length - 1].group_budget.length - 1].group_budget.length - 1].group_budget.push(data[i])
        //                 break;
        //         }
        //     }
        //     return result
        // },
        async searchGroupBudget() {
            this.editButton.edit_name               = false
            this.editButton.edit_button             = false
            this.editButton.edit_number             = false
            this.editButton.delete_data             = false
            this.saveForCheckValue.check_edit_event = null
            this.selectedGroup = { 
                "_id" : null,
                "group_name" : 'All'
            }
            this.tempDeleteGroup = []
            try {
                this.callApiPending++
                const { data } = await this.axios.get(`${this.$api_url}/group_budget/api/v1/search_group_budget?tax_id=${this.selectedBiz.tax_id || ''}&budget_type=${this.budget_type || ''}&type=${this.budgetType || ''}&year=${Number(this.year_selected)}`)
                if (data.status && Object.keys(data.data).length) {
                    // Page 1: ใช้ total ที่ API ส่งมาโดยตรง ไม่เอา group_budget มา Number()
                    this.sumTotal = data.data?.some_budget || 0
                    const baseTableData = this.convertDataApiToTable(
                        data.data.group_budget,
                        this.budgetType
                    )
                    const tableData = this.buildBudgetTableData(baseTableData)
                    this.budgetDashboardData = {
                        ...data.data,
                        "total"                  : MainFunction.addComma(Number(this.sumTotal || 0)),
                        "budget_plan"             : MainFunction.addComma(Number(data.data?.budget_plan || 0)),
                        "budget_actual"           : MainFunction.addComma(Number(data.data?.budget_actual || 0)),
                        "budget_total"            : MainFunction.addComma(Number(data.data?.budget_total || 0)),
                        "group_budget_body_table": tableData
                    }
                    this.budgetDashboardCloneData = structuredClone(this.budgetDashboardData)
                    this.budgetDashboardData.group_budget.unshift({
                        "_id"        : null,
                        "group_name" : 'All'
                    })
                    const newValueChanged = JSON.parse(JSON.stringify(this.budgetDashboardData.group_budget_body_table));
                    this.newValueChanged = newValueChanged
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollTop(0)
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollLeft(0)
                }
            } catch (error) {
                console.log(error)
                this.budgetDashboardData      = {}
                this.budgetDashboardCloneData = {}
                this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
            } finally {
                this.callApiPending--
                this.isReady = true
                this.$nextTick(() => {
                    this.updateBudgetGroupColumnWidth()
                })
            }
        },
        async searchGroupBudgetV2() {
            this.editButton.edit_name               = false
            this.editButton.edit_button             = false
            this.editButton.edit_number             = false
            this.editButton.delete_data             = false
            this.saveForCheckValue.check_edit_event = null
            this.selectedGroup = { 
                "_id" : null,
                "group_name" : 'All'
            }
            this.tempDeleteGroup = []
            try {
                this.callApiPending++
                const { data } = await this.axios.get(`${this.$api_url}/group_budget/api/v1/search_group_budget_v2?tax_id=${this.selectedBiz.tax_id || ''}&budget_type=${this.budget_type || ''}&type=${this.budgetType || ''}&year=${Number(this.year_selected)}`)
                if (data.status && Object.keys(data.data).length) {
                    this.budgetDashboardData = {
                        ...data.data,
                        "total"                   : MainFunction.addComma(Number(
                            (data.data?.group_budget || [])
                                .flatMap(e => Array.isArray(e?.group_budget_total) ? e.group_budget_total : [])
                                .reduce((sum, e) => {
                                    const amount = Number(String(e?.amount ?? 0).replace(/,/g, '').trim())
                                    return sum + (Number.isFinite(amount) ? amount : 0)
                                }, 0)
                            || 0
                        )),
                        "budget_plan"             : MainFunction.addComma(Number(data.data?.budget_plan   || '0')),
                        "budget_actual"           : MainFunction.addComma(Number(data.data?.budget_actual || '0')),
                        "budget_total"            : MainFunction.addComma(Number(data.data?.budget_total  || '0')),
                        "group_budget_body_table" : this.convertDataApiToTable(data.data.group_budget, this.budgetType)
                    }
                    this.budgetDashboardCloneData = structuredClone(this.budgetDashboardData)
                    this.budgetDashboardData.group_budget.unshift({
                        "_id"        : null,
                        "group_name" : 'All'
                    })
                    const newValueChanged = JSON.parse(JSON.stringify(this.budgetDashboardData.group_budget_body_table));
                    this.newValueChanged = newValueChanged
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollTop(0)
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollLeft(0)
                }
            } catch (error) {
                console.log(error)
                this.budgetDashboardData      = {}
                this.budgetDashboardCloneData = {}
                this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
            } finally {
                this.callApiPending--
                this.isReady = true
                this.$nextTick(() => {
                    this.updateBudgetGroupColumnWidth()
                })
            }
        },
        filterDataByGroup(data) {
            this.callApiPending++
            setTimeout(() => {
                const baseTableData = !data._id
                    ? this.convertDataApiToTable(this.budgetDashboardCloneData.group_budget, this.budgetType)
                    : this.convertDataApiToTable([data], this.budgetType)
                const tableData = this.buildBudgetTableData(baseTableData)
                this.budgetDashboardData.group_budget_body_table = tableData
                this.$nextTick(() => {
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollTop(0)
                    $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollLeft(0)
                    this.callApiPending--
                })
            }, 300);
        },
        saveAllData() {
            this.callApiPending++
            setTimeout(async () => {
                if (!this.$refs.budgetForm.validate()) {
                    this.callApiPending--
                    return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
                }
                if (this.saveForCheckValue.check_edit_event === 'number' && this.tempIndexEditNumber.length) {
                    this.closeEventEditNumberAfterHoldButton()
                }
                const tempNameChanged = Object.entries(this.saveForCheckValue.name).reduce((acc, [key, oldValue]) => {
                    const tempData = this.budgetDashboardData.group_budget_body_table[key] || null
                    if (!tempData) return acc
                    if (oldValue.name !== tempData.group_name) {
                        acc.push(tempData)
                    }
                    return acc
                }, [])
                let tempValueChanged = []
                Object.entries(this.saveForCheckValue.value).forEach(([key, oldValue]) => {
                    const [x] = key.split('_')
                    const tempData = this.budgetDashboardData.group_budget_body_table[x] || null
                    if (!tempData) return
                    const tempDataKey = tempData.level === 0
                        ? `level0-${tempData.group_budget_total_id || tempData._id}`
                        : `level-${tempData.level}-${tempData._id}`
                    if (!tempValueChanged.some(item => {
                        const itemKey = item.level === 0
                            ? `level0-${item.group_budget_total_id || item._id}`
                            : `level-${item.level}-${item._id}`
                        return itemKey === tempDataKey
                    })) {
                        tempValueChanged.push(tempData)
                    }
                })
                if (tempValueChanged.length || tempNameChanged.length || this.tempDeleteGroup.length) {
                    if (await this.updateBudgetDashboardAPI(tempNameChanged, tempValueChanged)) {
                        this.editButton = {
                            "edit_name"         : false,
                            "edit_button"       : false,
                            "edit_number"       : false,
                            "delete_data"       : false,
                            "history_dashboard" : false                   
                        }
                         if (this.page === 1) {
                            this.searchGroupBudget()
                        } else if (this.page === 2) {
                            this.searchGroupBudgetV2()
                        }
                        this.checkPrivilegeButton = true
                    }
                } else {
                    this.editButton = {
                        "edit_name"         : false,
                        "edit_button"       : false,
                        "edit_number"       : false,
                        "delete_data"       : false,
                        "history_dashboard" : false 
                    }
                   this.checkPrivilegeButton = true
                }
                this.saveForCheckValue = { name : {}, value : {}, check_edit_event: null }
                this.tempDeleteGroup   = []
                this.$nextTick(() => {
                    this.callApiPending--
                })
            }, 500);
        },
        calculateTotalNumber(item) {
                // item.sum_amount = 0
                // for (let i = 0; i < item.budget.length; i++) {
                //     item.sum_amount += (item.budget[i]?.amount === '-' || !item.budget[i]?.amount)? 0 : +item.budget[i].amount?.replace(/,/g, '')
                // }
            if (!item || !Array.isArray(item.budget)) {
                return
            }
            if (this.budget_type?.toUpperCase() === 'BUDGET') {
                item.budget.forEach((month) => {
                    if (month?.amount === null || month?.amount === undefined) return

                    const value = String(month.amount)
                        .replace(/,/g, '')
                        .replace(/[^\d.-]/g, '')

                    if (value.includes('.')) {
                        const [integer, decimal] = value.split('.')
                        month.amount = `${integer}.${decimal.slice(0, 2)}`
                    } else {
                        month.amount = value
                    }
                })
            }
            const total = item.budget.reduce((sum, month) => {
                const raw = String(month?.amount ?? '').replace(/,/g, '').trim()
                if (!raw || raw === '-') return sum
                const value = Number(raw)
                return Number.isFinite(value)? Number((sum + value).toFixed(2)) : sum
            }, 0)
            item.sum_amount = MainFunction.addComma(Number(total.toFixed(2)))
            this.$forceUpdate()
        },
        setValueForCheck(x, y) {
            const table = this.budgetDashboardData?.group_budget_body_table || []
            const tempData = table[x]
            if (!tempData) return
            if (y === undefined || y === null) {
                if (Object.prototype.hasOwnProperty.call(this.saveForCheckValue.name, x)) {
                    return
                }
                this.saveForCheckValue.name[x] = {
                    name: tempData.group_name,
                    id: tempData._id,
                    group_budget_total_id: tempData.group_budget_total_id || null,
                    is_group_total: !!tempData.is_group_total,
                    source_group_id: tempData.source_group_id || null
                }
            } else {
                const key = `${x}_${y}`
                if (Object.prototype.hasOwnProperty.call(this.saveForCheckValue.value, key)) {
                    return
                }
                this.saveForCheckValue.value[key] = {
                    amount: tempData.budget?.[y]?.amount ?? '',
                    id: tempData._id,
                    group_budget_total_id: tempData.group_budget_total_id || null,
                    source_group_id: tempData.source_group_id || null,
                    is_group_total: !!tempData.is_group_total
                }
            }
            this.tempIndexEditNumber = [...new Set(Object.keys(this.saveForCheckValue.value).map(key => parseInt(key.split('_')[0])).filter(Number.isFinite))]
        },
        convertTooltipHeader(level) {
            let text = null
            switch (level) {
                case 0:
                    text = 'groupTotal'
                    break
                case 1:
                    text = 'group'
                    break
                case 2:
                    text = 'sub group1'
                    break
                case 3:
                    text = 'sub group2'
                    break
                case 4:
                    text = 'sub group3'
                    break
                default:
                    text = 'groupTotal'
                    break
            }
            return text
        },
        openDeleteGroupModal(item, index) {
            const tempItem = {
                ...item,
                index     : index,
                type_text : this.convertTooltipHeader(item.level)
            }
            EventBus.$emit('openConfirmDeleteGroupModal', tempItem)
        },
        confirmDeleteGroup(item) {
            this.tempDeleteGroup.push(item)
            this.budgetDashboardData.group_budget_body_table = this.budgetDashboardData.group_budget_body_table.filter(e => !e.type.startsWith(item.type))
        },
        async updateBudgetDashboardAPI(nameChanged = [], valueChanged = []) {
            try {
                const tempPromise = []
                if (this.tempDeleteGroup.length) {
                    tempPromise.push({
                        method: 'POST',
                        baseURL: this.$api_url,
                        url: '/group_budget/api/v1/delete_group_subgroup',
                        data: {group: this.tempDeleteGroup.map(e => ({ _id: e._id }))
                        }
                    })
                }
                if (nameChanged.length) {
                    const tempBodyEditName = {
                        group: nameChanged.filter(e => e && !e.is_group_total)
                            .map(e => ({
                                _id: e._id || null,
                                group_name: e.group_name 
                            })).filter(e => e._id && !['plan', 'actual'].includes( e?.group_name?.toLowerCase())),
                        group_total: nameChanged
                            .filter(e => e && e.is_group_total && e.level === 0)
                            .map(e => ({
                                _id: e.group_budget_total_id || null,
                                group_total_name: e.group_name
                            }))
                            .filter(e => e._id)
                    }
                    tempPromise.push({
                        method: 'POST',
                        baseURL: this.$api_url,
                        url: '/group_budget/api/v1/edit_group_name',
                        data: tempBodyEditName
                    })
                }
                if (valueChanged.length) {
                    const level0Changed = valueChanged.filter(
                        e => e.level === 0
                    )
                    const otherLevelChanged = valueChanged.filter(
                        e => e.level !== 0
                    )
                    level0Changed.forEach(e => {
                        const sourceItem =
                            this.budgetDashboardData.group_budget_body_table.find(
                                item => item._id === e._id
                            )
                        const foundItem =
                            this.newValueChanged.find(
                                item => item._id === e._id
                            ) || sourceItem || e
                        const tempBodyLevel0 = {
                            _id: e.group_budget_total_id === '-' ?   '' : e.group_budget_total_id  || '',
                            transaction_id: e.transaction_id || e._id,
                            budget: e.budget?.map((e1, index) => {
                                const rawAmount =
                                    foundItem?.budget?.[index]?.amount
                                const itemAmount =
                                    rawAmount === '-'
                                        ? '0.00'
                                        : parseFloat(
                                            String(
                                                rawAmount ?? '0'
                                            ).replace(/,/g, '')
                                        ).toFixed(2)

                                const e1Amount =
                                    e1.amount === '-'
                                        ? '0.00'
                                        : String(e1.amount ?? '0')
                                return {
                                    month: e1.month,
                                    amount:
                                        e1.amount === '-'
                                            ? null
                                            : Number(
                                                String(
                                                    e1.amount ?? '0'
                                                ).replace(/,/g, '') || '0'
                                            ),
                                    edit:
                                        e1Amount.replace(/,/g, '') !==
                                        itemAmount
                                }
                            })
                        }
                        tempPromise.push({
                            method: 'POST',
                            baseURL: this.$api_url,
                            url: '/group_budget/api/v1/add_group_budget_total',
                            data: tempBodyLevel0
                        })
                    })
                    if (otherLevelChanged.length) {
                        const tempBodyOtherLevel = {
                            type: this.budgetType,
                            group: otherLevelChanged.map(e => {
                                const sourceItem =
                                    this.budgetDashboardData.group_budget_body_table.find(
                                        item => item._id === e._id
                                    )

                                const foundItem =
                                    this.newValueChanged.find(
                                        item => item._id === e._id
                                    ) || sourceItem || e

                                return {
                                    _id: e._id,
                                    transaction_id:
                                        e.transaction_id || e._id,
                                    budget: e.budget?.map((e1, index) => {
                                        const rawAmount =
                                            foundItem?.budget?.[index]?.amount

                                        const itemAmount =
                                            rawAmount === '-'
                                                ? '0.00'
                                                : parseFloat(
                                                    String(
                                                        rawAmount ?? '0'
                                                    ).replace(/,/g, '')
                                                ).toFixed(2)

                                        const e1Amount =
                                            e1.amount === '-'
                                                ? '0.00'
                                                : String(e1.amount ?? '0')

                                        return {
                                            ...e1,
                                            amount:e1.amount === '-'? null: Number( String(e1.amount ?? '0').replace(/,/g, '') || '0'),
                                            edit:
                                                e1Amount.replace(/,/g, '') !==
                                                itemAmount
                                        }
                                    }),
                                    total_budget: Number(
                                        String(
                                            e.sum_amount ?? '0'
                                        ).replace(/,/g, '') || '0'
                                    )
                                }
                            })
                        }
                        tempPromise.push({
                            method: 'POST',
                            baseURL: this.$api_url,
                            url: '/group_budget/api/v1/edit_group_month',
                            data: tempBodyOtherLevel
                        })
                    }
                }
                if (!tempPromise.length) {
                    return true
                }
                const results = await Promise.allSettled(
                    tempPromise.map(request => this.axios(request))
                )
                const failed = results.filter(result => {
                    if (result.status === 'rejected') {
                        return true
                    }
                    return result.value?.data?.status !== true
                })
                if (failed.length === 0) {
                    this.alert('อัปเดตข้อมูลสำเร็จ', 'Success','success')
                    return true
                }
               this.alert(`อัปเดตข้อมูลไม่สำเร็จ`, 'Fail', 'error')
                return false
            } catch (error) {
                console.error(error)
                this.alert(`อัปเดตข้อมูลไม่สำเร็จ`, 'Fail', 'error')
                return false
            }
        },
        async getListHistoryBudget(trig_state = false) {
            try {
                this.callApiPending++
                const { data } = await this.axios.get(`${this.$api_url}/group_budget/api/v1/list_history?tax_id=${this.selectedBiz.tax_id || ''}&budget_type=${this.budget_type?.toUpperCase() || ''}&type=${this.budgetType || ''}&year=${Number(this.year_selected)}`)
                if (data.status) {
                    this.selectedHistoryBudget = {}
                    this.historyBudgetList     = []
                    for (let i = 0; i < data.data.length; i++) {
                        const tempData = data.data[i].editor
                        this.historyBudgetList.push({
                            ...data.data[i],
                            history_date   : MainFunction.shortDate(data.data[i].history_date_string || null),
                            edit_full_name : `${tempData.first_name_th || tempData.first_name_eng} ${tempData.last_name_th || tempData.last_name_eng}`
                        })
                    }
                }
            } catch (error) {
                console.log(error)
                this.selectedHistoryBudget = {}
                this.historyBudgetList     = []
            } finally {
                this.callApiPending--
                if (trig_state) {
                    this.editButton.history_dashboard = !this.editButton.history_dashboard
                }
            }
        },
        async searchHistoryBudget(editors, index) {
            if (index === this.selectedHistoryBudget?.index) {
                return
            }
            this.selectedHistoryBudget = { ...editors, index }
            this.$forceUpdate()
            this.selectedGroup = {
                "_id": null,
                "group_name": 'All'
            }
            try {
                this.callApiPending++
                const { data } = await this.axios.get(`${this.$api_url}/group_budget/api/v1/history_group_budget?tax_id=${this.selectedBiz.tax_id || ''}&budget_type=${this.budget_type || ''}&type=${this.budgetType || ''}&history_date_string=${editors.history_date_string || ''}&year=${Number(this.year_selected)}`)
                if (data.status && data.data && Object.keys(data.data).length) {
                    const sourceGroups = Array.isArray(data.data.group_budget)
                        ? data.data.group_budget
                        : []
                    // History ต้องใช้โครงสร้างเดียวกับหน้าปัจจุบัน
                    // เพื่อให้ Group Total / Budget / Total column แสดงครบ
                    const baseTableData = this.convertDataApiToTable(
                        sourceGroups,
                        this.budgetType
                    )
                    const tableData = this.buildBudgetTableData(baseTableData)
                    this.budgetDashboardData = {
                        ...data.data,
                        "total": MainFunction.addComma(Number(this.sumTotal || 0)),
                        "budget_plan": MainFunction.addComma(
                            Number(data.data?.budget_plan || 0)
                        ),
                        "budget_actual": MainFunction.addComma(
                            Number(data.data?.budget_actual || 0)
                        ),
                        "budget_total": MainFunction.addComma(
                            Number(data.data?.budget_total || 0)
                        ),
                        "group_budget_body_table": tableData
                    }
                    // เก็บ snapshot ของ History เพื่อให้ filter group
                    // และการตรวจสอบตำแหน่งที่แก้ยังอ้างอิงข้อมูลชุดเดียวกัน
                    this.budgetDashboardCloneData = structuredClone(
                        this.budgetDashboardData
                    )

                    this.newValueChanged = JSON.parse(
                        JSON.stringify(tableData)
                    )

                    this.budgetDashboardData.group_budget = Array.isArray(
                        this.budgetDashboardData.group_budget
                    )
                        ? this.budgetDashboardData.group_budget
                        : []

                    this.budgetDashboardData.group_budget.unshift({
                        "_id": null,
                        "group_name": "All"
                    })
                    this.$nextTick(() => {
                        $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollTop(0)
                        $(".data-table-dashboard-budget > .v-data-table__wrapper").scrollLeft(0)
                    })
                } else {
                    this.budgetDashboardData = {}
                    this.budgetDashboardCloneData = {}
                    this.newValueChanged = []
                    this.sumTotal = 0
                }
            } catch (error) {
                console.log(error)
                this.budgetDashboardData = {}
                this.budgetDashboardCloneData = {}
                this.newValueChanged = []
                this.sumTotal = 0
            } finally {
                this.callApiPending--
            }
        },
        editNameToggle() {
            if (!this.$refs.budgetForm.validate()) {
                return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
            }
            this.callApiPending++
            setTimeout(() => {
                this.editButton.edit_name = !this.editButton.edit_name
                this.$nextTick(() => {
                    this.saveForCheckValue.check_edit_event = 'name'
                    this.callApiPending--
                })
            }, 500);
        },
        editNumberToggle() {
            if (!this.$refs.budgetForm.validate()) {
                return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
            }
            if (this.saveForCheckValue.check_edit_event === 'number' && this.tempIndexEditNumber.length) {
                this.closeEventEditNumberAfterHoldButton()
            } else {
                this.tempIndexEditNumber = []
            }
            this.editButton.edit_number = !this.editButton.edit_number
            this.saveForCheckValue.check_edit_event = 'number'
        },
        closeEventEditNumberAfterHoldButton() {
            this.tempIndexEditNumber = [...new Set(this.tempIndexEditNumber)]
            if (this.tempIndexEditNumber.length) {
                for (let i = 0; i < this.tempIndexEditNumber.length; i++) {
                    this.budgetDashboardData.group_budget_body_table[this.tempIndexEditNumber[i]].edit_number_status = false
                }
            }
            this.tempIndexEditNumber = []
        },
        eachEditNumberToggle(item) {
            if (item.edit_number_status) {
                for (let i = 0; i < item.budget.length; i++) {
                    if (!item.budget[i].amount) {
                        this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
                        return
                    }
                }
            }
            item.edit_number_status = !item.edit_number_status
        },
        editDeleteToggle() {
            this.callApiPending++
            setTimeout(() => {
                this.editButton.delete_data = !this.editButton.delete_data
                this.$nextTick(() => {
                    this.saveForCheckValue.check_edit_event = 'delete'
                    this.callApiPending--
                })
            }, 500);
        },
        openAddGroupModal() {
            const temp_data = {
                tax_id      : this.selectedBiz.tax_id,
                type        : this.budgetType,
                budget_type : this.budget_type,
                budget      : this.budgetDashboardCloneData,
                year        : Number(this.year_selected)
            }
            this.saveForCheckValue.check_edit_event = 'add_group'
            EventBus.$emit('openAddGroupBudgetDashboardModal', temp_data)
        },
        changeTypeEvent() {
            if (this.editButton.history_dashboard) {
                this.getListHistoryBudget()
                this.selectedHistoryBudget = {}
            }
            if (this.page === 1) {
        this.searchGroupBudget()
      } else if (this.page === 2) {
        this.searchGroupBudgetV2()
      }
        },
        addFileExcelBudgeting() {
            EventBus.$emit('addFileExcelBudgeting', this.budget_type , this.year_selected,this.page)
        },
        alert(title = '', text = 'Fail', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text:  text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            })
        }
    },
}
</script>

<style>
    .background-card-budgeting-permission {
        margin: 60px 3.26% 56px 3.26% !important;
        background-color: white;
        border-radius: 23px !important;
    }

    .button-header-budget-permission {
        border-radius: 10px;
        color: white !important;
        font-size: 16px;
        font-weight: 700;
        box-shadow: none;
    }

    .button-header-budget-permission:not(.v-btn--round).v-size--default {
        min-width: auto;
    }

    .topics-budget-box-header {
        font-weight: 700;
        font-size: 15px;
    }

   .topics-budget-box-value,
        .topics-budget-box-value.v-text-field--outlined {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }

    .topics-budget-box-value .v-input__control,
        .topics-budget-box-value .v-input__slot {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
    }

    .topics-budget-box-value .v-input__slot::before,
        .topics-budget-box-value .v-input__slot::after {
        display: none !important;
        border: none !important;
        content: none !important;
    }

    .topics-budget-box-value fieldset {
        display: none !important;
        border: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
    }

    .topics-budget-box-value legend {
        display: none !important;
    }

    .topics-budget-box-value .v-input__control .v-input__slot .v-text-field__slot input {
        max-height: 62px;
    }

    .button-group-budgeting-permission {
        font-weight: 700 !important;
        font-size: 15px !important;
        color: black;
        letter-spacing: 1px;
    }

    .active-button-group-budgeting-permission {
        background-color: #414040;
        color: white !important;
    }

    .data-table-dashboard-budget {
        width: 100%;
        max-width: 100% !important;
        min-width: 0 !important;
        border-right: none !important;
        border: 1px solid #E0E0E0;
        border-radius: 4px !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        height: calc(100vh - 174px);
        overflow-x: auto !important;
        overflow-y: auto !important;
        box-sizing: border-box !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper > table {
        border-collapse: separate !important;
        border-spacing: 0 !important;
        width: max-content !important;
        min-width: 1400px !important;
        max-width: none !important;
        table-layout: auto !important;
        box-sizing: border-box !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper > table > thead > tr > th:first-child,
    .data-table-dashboard-budget > .v-data-table__wrapper > table > tbody > tr > td:first-child {
        width: 20% !important;
        min-width: 20% !important;
        max-width: 20% !important;
        box-sizing: border-box !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper > table > thead > tr > th:not(:first-child),
    .data-table-dashboard-budget > .v-data-table__wrapper > table > tbody > tr > td:not(:first-child) {
        width: 95px !important;
        min-width: 95px !important;
        max-width: 95px !important;
        box-sizing: border-box !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper::-webkit-scrollbar-track {
        background-color: #f1f1f1 !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper::-webkit-scrollbar-thumb {
        background-color: #888;
        border-radius: 10px;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
        background-color: #333333;
    }

    .group-name-dashboard-budget-table-header,
    .total-dashboard-budget-table-header {
        position: sticky !important;
        top: 0;
        height: 66px !important;
        font-size: 15px !important;
        font-weight: 700;
        color: white !important;
        background-color: #333333 !important;
        z-index: 3 !important;
    }

    .group-name-dashboard-budget-table-header {
        left: 0 !important;
        padding-right: 8% !important;
    }

    .total-dashboard-budget-table-header {
        right: 0 !important;
    }

    .dashboard-budget-table-header {
        font-size: 15px !important;
        font-weight: 700;
        color: white !important;
        border-bottom: none !important;
        height: 66px !important;
        text-align: center !important;
        background-color: #333333 !important;
    }

    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td {
        height: 25px !important;
        padding-top: 1px !important;
        padding-bottom: 1px !important;
        box-sizing: border-box !important;
    }

.dashboard-budget-table-body {
    position: relative !important;
    z-index: 1 !important;
    border-bottom: none !important;
    background: #FFFFFF !important;
    background-color: #FFFFFF !important;
    background-image: none !important;
    opacity: 1 !important;
    overflow: visible !important;
    box-sizing: border-box !important;
    background-clip: padding-box !important;
    padding-top: 1px !important;
    padding-bottom: 1px !important;
}

    .dashboard-budget-table-body.pt-7 {
        padding-top: 28px !important;
    }

    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table {
        width: max(1800px, 100%) !important;
        min-width: 1800px !important;
        max-width: none !important;
        table-layout: fixed !important;
        border-collapse: separate !important;
        border-spacing: 0 !important;
    }

    /* คอลัมน์ Group = 20% ของตารางทุกหน้าจอ */
    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:first-child,
    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:first-child {
        width: 20% !important;
        min-width: 20% !important;
        max-width: 20% !important;
        box-sizing: border-box !important;
    }

    /* ช่องยอดแต่ละเดือน/Total ขยายตามความยาวของตัวเลขจริง
    และเว้นระยะซ้าย-ขวาไม่ให้ตัวเลขชิดขอบ */
    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:not(:first-child),
    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td.dashboard-budget-table-body {
        width: max-content !important;
        min-width: 110px !important;
        max-width: none !important;
        white-space: nowrap !important;
        overflow: visible !important;
        box-sizing: border-box !important;
    }

    /* ตัวเลขต้องแสดงครบ ห้ามตัด และให้ cell ขยายตามข้อความ */
    .dashboard-budget-cell-row {
        width: max-content !important;
        min-width: 100% !important;
        max-width: none !important;
        padding-left: 4px !important;
        padding-right: 4px !important;
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: clip !important;
        box-sizing: border-box !important;
    }

    .dashboard-budget-table-body > .dashboard-budget-cell-row,
    .dashboard-budget-cell-row {
        margin-left: 0 !important;
        margin-right: 0 !important;
        width: max-content !important;
        min-width: 100% !important;
        max-width: none !important;
        box-sizing: border-box !important;
        overflow: visible !important;
        position: relative !important;
        opacity: 1 !important;
        white-space: nowrap !important;
    }

    .group-name-dashboard-table-body {
        position: sticky !important;
        left: 0 !important;
        z-index: 2 !important;
        border-bottom: none !important;
        background: #FFFFFF !important;
        background-color: #FFFFFF !important;
        background-image: none !important;
        opacity: 1 !important;
        transform: none !important;
        box-shadow: 8px 0 10px rgba(0, 0, 0, 0.05) !important;
    }

    .total-budget-dashboard-table-body {
        position: sticky !important;
        right: 0 !important;
        z-index: 2 !important;
        border-bottom: none !important;
        background: #FFFFFF !important;
        background-color: #FFFFFF !important;
        background-image: none !important;
        opacity: 1 !important;
        transform: none !important;
        overflow: visible !important;
        box-sizing: border-box !important;
        box-shadow: -8px 0 10px rgba(0, 0, 0, 0.08) !important;
    }

    .total-budget-dashboard-table-body > .dashboard-budget-cell-row {
        z-index: 2 !important;
    }

    .dashboard-group-name {
        width: 100%;
        display: flex;
        align-items: center;
        white-space: nowrap;
        overflow: hidden;
        box-sizing: border-box;
    }

    .dashboard-group-name-text {
        display: block !important;
        flex: 1 1 auto !important;
        min-width: 0 !important;
        max-width: 100% !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        box-sizing: border-box !important;
    }

    .dashboard-group-name-text:hover {
        cursor: help;
    }

    .dashboard-group-name-total {
        background-color: #A9C5C3 !important;
        min-height: 18px;
        height: 18px;
        line-height: 18px;
        padding-left: 10px;
        opacity: 1 !important;
    }

    .dashboard-group-name-detail {
        background-color: transparent;
        min-height: auto;
        height: auto;
        line-height: normal;
        padding-left: 20px;
    }

    .dashboard-group-name-edited {
        background-color: #CFE2B3 !important;
        opacity: 1 !important;
    }

    .dashboard-row-level-2 {
        background-color: #b8e3e0 !important;
        opacity: 1 !important;
    }

    .budget-dashboard-dropdown-select-group.v-text-field--outlined.v-input--dense.v-text-field--outlined
    > .v-input__control
    > .v-input__slot,
    .budget-dashboard-dropdown-select-year.v-text-field--outlined.v-input--dense.v-text-field--outlined
    > .v-input__control
    > .v-input__slot {
        min-height: auto !important;
    }

    .budget-dashboard-dropdown-select-group .v-input__control .v-input__slot,
    .budget-dashboard-dropdown-select-year .v-input__control .v-input__slot {
        padding-right: 5px !important;
    }

    .budget-dashboard-dropdown-select-group,
    .budget-dashboard-dropdown-select-year {
        border-radius: 10px;
        font-size: 15px;
    }

    .no-data-budget-dashboard-table {
        width: max-content;
        height: 100px;
        position: sticky;
        font-size: 25px;
        font-weight: 700;
        left: 45vw;
        color: #D3D3D3;
    }

    .input-each-group-dashboard-budget > .v-input__control > .v-input__slot {
        min-height: auto;
        padding: 0 7px !important;
    }

    .input-each-group-dashboard-budget {
        font-size: 13px;
    }

    .dashboard-group-edit-row {
        min-height: 22px;
        flex-wrap: nowrap;
    }

    .dashboard-group-action {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 15px;
        min-width: 15px;
        margin-right: 5px;
    }

    .dashboard-group-action .v-btn {
        margin: 0 !important;
    }

    .dashboard-group-edit-input {
        flex: 1 1 auto;
        min-width: 0;
        margin: 0 !important;
    }

    .centered-input-dashboard-budget .v-input__control .v-input__slot .v-text-field__slot input {
        text-align: center;
    }

    .table-budget-dashboard-card {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        background-color: #FFFFFF;
        border-radius: 23px;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25);
        box-sizing: border-box !important;
    }

    .table-budget-dashboard-card > .v-row {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
    }

    .budget-dashboard-card1 {
        margin: 60px 0 56px 0 !important;
        padding: 0 3.26% 0 0%;
    }

    .budget-dashboard-card {
        margin: 60px 0 56px 0 !important;
        padding: 0 3.26% 0 3.26%;
    }

    .animate-history-dashboard-budget-card {
        opacity: 0;
        transform: translateX(-100%) rotateY(-90deg);
        animation: history-card-animation 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) forwards;
    }

    .history-dashboard-budget-card {
        width: auto !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25);
        border-radius: 0px 23px 23px 0px;
    }

    .header-history-budget-dashboard {
        line-height: 20px;
        font-weight: 400;
        font-size: 13px;
    }

    .budget-history-table-card {
        height: 100%;
        width: auto;
        background-color: white;
        border-radius: 0px 23px 23px 0px !important;
    }

    .scrollbar-history-budget-dashboard-tab {
        overflow-y: auto;
        max-height: calc(100vh - 119px);
        scroll-behavior: smooth;
    }

    .scrollbar-history-budget-dashboard-tab::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    .scrollbar-history-budget-dashboard-tab::-webkit-scrollbar-thumb {
        background-color: #F0F0F0;
    }

    .scrollbar-history-budget-dashboard-tab::-webkit-scrollbar-thumb:hover {
        background-color: #D9D9D9;
    }

    .active-selected-history-budget-dashboard, .selected-history-budget-dashboard:hover {
        color: black !important;
        font-weight: 700;
        cursor: pointer;
    }

    .active-selected-event-button-mobile {
        margin: 0 8px;
        color: black !important;
        background-color: #f1f1f1 !important;
    }

    .requirement-text {
        display: block;
        padding: 12px 12px;
        border-radius: 20px;
        line-height: 1.6;
        font-size: 14px;
        color: #ffffff;
    }

    .requirement-text-2 strong {
        color: #f76300;
    }

    .requirement-text strong {
        color: #ffa200;
    }

    /* กำหนดระยะห่างของแถวตาราง:
       ทุก Level ด้านบน/ล่าง 1px
       Level 0 ที่มี pt-7 ด้านบน 28px */
    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td.pt-7 {
        padding-top: 28px !important;
    }

    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td
    > .standard-row {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    .text-bold {
        font-weight: bold;
    }
    .topics-budget-box-header {
        color: #000000 !important;
    }

    .budget-value input {
        color: #FFFFFF !important;
        -webkit-text-fill-color: #FFFFFF !important;
        font-weight: 700 !important;
        font-style: normal !important;
        font-size: clamp(14px, 1.55vw, 16px) !important;
        line-height: 100% !important;
        letter-spacing: 0 !important;
        vertical-align: middle;
    }

    .plan-value input,
    .actual-value input {
        color: #555555 !important;
        -webkit-text-fill-color: #555555 !important;
        font-weight: 700 !important;
        font-style: normal !important;
        font-size: clamp(14px, 1.55vw, 16px) !important;
        line-height: 100% !important;
        letter-spacing: 0 !important;
        vertical-align: middle;
    }

    .total-value input {
        color: #000000 !important;
        -webkit-text-fill-color: #000000 !important;
        font-weight: 700 !important;
        font-style: normal !important;
        font-size: clamp(14px, 1.55vw, 16px) !important;
        line-height: 100% !important;
        letter-spacing: 0 !important;
        vertical-align: middle;
    }

    @keyframes history-card-animation {
        0% {
            opacity: 0;
            transform: translateX(-100%) rotateY(-90deg);
        }
        100% {
            opacity: 1;
            transform: translateX(0%) rotateY(0deg);
        }
    }

    @media only screen and (max-width: 1000px) {
        .group-name-dashboard-budget-table-header {
            left: auto !important;
        }

        .total-dashboard-budget-table-header {
            right: auto !important;
        }

        .group-name-dashboard-table-body,
        .total-budget-dashboard-table-body {
            position: static !important;
            transform: none !important;
        }

        .data-table-dashboard-budget > .v-data-table__wrapper {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            overflow-x: auto !important;
            overflow-y: auto !important;
        }

        .data-table-dashboard-budget > .v-data-table__wrapper > table {
            width: 1800px !important;
            min-width: 1800px !important;
            max-width: none !important;
            table-layout: fixed !important;
        }

        .data-table-dashboard-budget > .v-data-table__wrapper > table > thead > tr > th:first-child,
        .data-table-dashboard-budget > .v-data-table__wrapper > table > tbody > tr > td:first-child {
            width: 20% !important;
            min-width: 20% !important;
            max-width: 20% !important;
        }

        .data-table-dashboard-budget > .v-data-table__wrapper > table > thead > tr > th:not(:first-child),
        .data-table-dashboard-budget > .v-data-table__wrapper > table > tbody > tr > td:not(:first-child) {
            width: max-content !important;
            min-width: 110px !important;
            max-width: none !important;
            white-space: nowrap !important;
            overflow: visible !important;
        }

        .group-name-dashboard-table-body {
            position: sticky !important;
            left: 0 !important;
            z-index: 2 !important;
        }

        .total-budget-dashboard-table-body {
            position: sticky !important;
            right: 0 !important;
            z-index: 2 !important;
        }
    }

    @media only screen and (max-width: 960px) {
        .budget-dashboard-card1 {
            margin: 60px 0 56px 0 !important;
            padding: 0 3.26% 0 3.26%;
        }

        .budget-history-table-card {
            height: auto !important;
            border-radius: 23px !important;
        }

        .scrollbar-history-budget-dashboard-tab {
            max-height: calc(100vh - 466px);
        }
    }

    @media only screen and (min-width: 960px) and (max-width: 1263px) {
        .scrollbar-history-budget-dashboard-tab {
            max-height: calc(100vh - 21px);
        }
    }

    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table {
        width: max(1800px, 100%) !important;
        min-width: 1800px !important;
        max-width: none !important;
        table-layout: fixed !important;
    }

    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:first-child,
    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:first-child {
        width: 20% !important;
        min-width: 20% !important;
        max-width: 20% !important;
        box-sizing: border-box !important;
    }

    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table
    > thead
    > tr
    > th:not(:first-child),
    .data-table-dashboard-budget
    > .v-data-table__wrapper
    > table
    > tbody
    > tr
    > td:not(:first-child) {
        width: 6.153846% !important;
        min-width: 110px !important;
        max-width: none !important;
        white-space: nowrap !important;
        box-sizing: border-box !important;
    }

    .group-name-dashboard-budget-table-header,
    .group-name-dashboard-table-body {
        width: 20% !important;
        box-sizing: border-box !important;
    }

    .dashboard-group-name {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        overflow: hidden !important;
    }

    .dashboard-group-name-text {
        min-width: 0 !important;
        max-width: 100% !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        overflow-x: auto !important;
        overflow-y: auto !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper > table {
        width: max-content !important;
        min-width: 1400px !important;
        max-width: none !important;
        table-layout: auto !important;
        border-collapse: separate !important;
        border-spacing: 0 !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper > table
    > thead > tr > th.budget-group-column,
    .data-table-dashboard-budget > .v-data-table__wrapper > table
    > tbody > tr > td.budget-group-column {
        width: var(--budget-group-column-width, 20%) !important;
        min-width: var(--budget-group-column-width, 20%) !important;
        max-width: var(--budget-group-column-width, 20%) !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
        white-space: nowrap !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper > table
    > tbody > tr > td.budget-group-column > .dashboard-group-name {
        display: flex !important;
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
    }

    .data-table-dashboard-budget .dashboard-group-name-text {
        display: block !important;
        flex: 1 1 auto !important;
        min-width: 0 !important;
        width: 0 !important;
        max-width: 100% !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        box-sizing: border-box !important;
    }

    /* Group header select must also stay inside the 20% column */
    .data-table-dashboard-budget .budget-group-column
    .budget-dashboard-dropdown-select-group {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
    }

    .data-table-dashboard-budget .budget-group-column
    .v-input__control,
    .data-table-dashboard-budget .budget-group-column
    .v-input__slot {
        min-width: 0 !important;
        max-width: 100% !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper > table
    > thead > tr > th:nth-child(n+2):nth-child(-n+13),
    .data-table-dashboard-budget > .v-data-table__wrapper > table
    > tbody > tr > td.dashboard-budget-table-body:not(.total-budget-dashboard-table-body) {
        width: max-content !important;
        min-width: 110px !important;
        max-width: none !important;
        white-space: nowrap !important;
        overflow: visible !important;
        box-sizing: border-box !important;
    }

    .data-table-dashboard-budget .dashboard-budget-cell-row {
        width: max-content !important;
        min-width: 100% !important;
        max-width: none !important;
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: clip !important;
        box-sizing: border-box !important;
    }

    .data-table-dashboard-budget > .v-data-table__wrapper > table
    > thead > tr > th:last-child,
    .data-table-dashboard-budget > .v-data-table__wrapper > table
    > tbody > tr > td.total-budget-dashboard-table-body {
        width: 120px !important;
        min-width: 120px !important;
        max-width: 120px !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        box-sizing: border-box !important;
    }

    .data-table-dashboard-budget .total-budget-dashboard-table-body
    .dashboard-budget-cell-row {
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
    }

</style>
